import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Layout from './components/Layout.tsx';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { ThemeProvider } from './contexts/theme-provider.tsx';
import ChangePassword from './pages/ChangePassword.tsx';
import CreateUrl from './pages/CreateUrl.tsx';
import Login from './pages/Login.tsx';
import Settings from './pages/Settings.tsx';
import UrlList from './pages/UrlList.tsx';
import UrlStats from './pages/UrlStats.tsx';
import Users from './pages/Users.tsx';

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="url-shortener-theme">
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Protected Routes - Only accessible when authenticated */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Layout />}>
                <Route index element={<CreateUrl />} />
                <Route path="urls" element={<UrlList />} />
                <Route path="urls/:shortCode" element={<UrlStats />} />
                <Route path="settings" element={<Settings />} />
                <Route path="users" element={<Users />} />
                <Route path="change-password" element={<ChangePassword />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
